import generalTransformer from '@/services/general/filters/serverTableDataTransformer';
import HTTP from '../../HTTP';

const URL_BASE = 'gescom/Parution/';

export async function update(data) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', data);
  return response;
}

export async function create(data) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', data);
  return response;
}

export async function get(id) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: id } });
  return response;
}

export async function getWithDispoAsync(id) {
  const response = await HTTP.get(URL_BASE + 'GetWithDispoAsync', { params: { id: id } });
  return response;
}

export async function getAll(serverTabledata) {
  const inputServer = generalTransformer(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function generationParutions(data) {
  const response = await HTTP.post(URL_BASE + 'GenerationParutionsAsync', data);
  return response;
}

export async function PGetAllVendableAsync(serverTabledata) {
  const inputServer = generalTransformer(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllVendableAsync', inputServer);
  return response;
}

export async function PGetAllAvecDispoAsync(serverTabledata) {
  const inputServer = generalTransformer(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAvecDispoAsync', inputServer);
  return response;
}

export async function archiver(id, status) {
  const response = await HTTP.post(URL_BASE + 'ArchiverAsync', { id: id, archiver: status });
  return response;
}

export async function deleteParution(ids) {
  const response = await HTTP.post(URL_BASE + 'PDeleteAllParutionAsync', { parutionIds: ids });
  return response;
}

export async function getTexteEmailByEtatBatAsync(data) {
  const response = await HTTP.get(URL_BASE + 'GetTexteEmailByEtatBatAsync', {
    params: data,
  });
  return response;
}

export async function getCheminFer(id) {
  const response = await HTTP.get(URL_BASE + 'GetCheminFerAsync', { params: { id } });
  return response;
}

export async function sauvegardeCheminFer(data) {
  const response = await HTTP.post(URL_BASE + 'SauvegardeCheminFerAsync', data);
  return response;
}
